import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Checkbox } from '../../../components/ui/checkbox';
import { Label } from '../../../components/ui/label';
import AvailableColumnsPanel from './AvailableColumnsPanel';
import SelectedColumnsList from './SelectedColumnsList';
import { useDispatch, useSelector } from 'react-redux';
import { detachExtCustomColumn } from '../../../store/extCustomColumns/actions';
import { useExtCustomColumns } from '../../../contexts/extractions/ExtCustomColumnContext';

// Footer Component - Single Responsibility: Display actions and settings
const Footer = ({ isDefault, onIsDefaultToggle }) => {
  return (
    <div className="mt-3 flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="isDefault"
          checked={isDefault}
          onCheckedChange={onIsDefaultToggle}
        />
        <Label htmlFor="isDefault" className="text-sm font-normal cursor-pointer">
          The selected columns will be set as default and remain selected automatically.
        </Label>
      </div>
    </div>
  );
};

// Main Root Component - Dependency Inversion: Coordinates all child components
const ColumnSelectionArea = () => {
  const dispatch = useDispatch();
  const { handleToggleColumn, handleRemoveColumn, handleRemoveCustomColumn, handleToggleIsDefault } = useExtCustomColumns();

  const [searchTerm, setSearchTerm] = useState('');
  const { extVersion } = useSelector((state) => state.ExtVersions);

  if (!extVersion) return null;

  return (
    <div className="max-w-8xl mx-auto">
      <div className="flex items-stretch gap-0 h-[300px]">
        <AvailableColumnsPanel
          selectedIds={extVersion.selected_columns}
          onToggle={handleToggleColumn}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
        />
        
        <div className="flex items-center justify-center px-4">
          <ChevronRight className="w-8 h-8 text-muted-foreground" />
        </div>
        
        <SelectedColumnsList
          selectedIds={extVersion.selected_columns}
          customColIds={extVersion.custom_columns}
          onRemove={handleRemoveColumn}
          onCustomColRemove={handleRemoveCustomColumn}
          detachCustomColumn={(id) => {
            dispatch(detachExtCustomColumn(id))
          }}
        />
      </div>

      <Footer
        isDefault={extVersion.is_default ?? false}
        onIsDefaultToggle={handleToggleIsDefault}
      />
    </div>
  );
};

export default ColumnSelectionArea;